export const styles = (theme) => ({
  root: {
    width: '90%',
    margin: 'auto'
  },
  card: {
    margin: '3rem 0 3rem 0',
    borderRadius: 10
  },
  cardCam: {
    margin: '3rem 0 3rem 0',
    borderRadius: 10,
    minWidth: 275,
    maxWidth: 500
  },
  grid: {
    marginLeft: '-1rem',
    marginTop: '-1rem'
  },
  form: {
    padding: '3.5rem'
  },
  formGroup: {
    '& > div': {
      marginBottom: '2rem',
      '& label': {
        color: '#2A324F',
        fontWeight: 'bold'
      }
    }
  },
  btn: {
    backgroundColor: '#1174BE',
    float: 'right',
    color: '#FFF'
  }
});
